class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.querySelector('button[type="reset"]').addEventListener(
      'click',
      this.reset.bind(this)
    );

    // Add form submission handler for SKU normalization
    const searchForm = this.querySelector('form.search');
    if (searchForm) {
      searchForm.addEventListener('submit', this.onFormSubmit.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  normalizeSearchTerm(searchTerm) {
    const isFourDigitNumber = /^\d{4}$/.test(searchTerm);
    
    if (isFourDigitNumber) {
      return '0' + searchTerm;
    }
    
    return searchTerm;
  }

  onFormSubmit(event) {
    // Only normalize if predictive search is not enabled (predictive-search handles its own normalization)
    const predictiveSearch = this.closest('predictive-search');
    if (predictiveSearch) {
      return; // Let predictive-search handle normalization
    }

    const searchInput = this.querySelector('input[type="search"][name="q"]');
    if (searchInput) {
      const searchTerm = searchInput.value.trim();
      if (searchTerm) {
        const normalizedTerm = this.normalizeSearchTerm(searchTerm);
        if (normalizedTerm !== searchTerm) {
          // Update the input value with normalized term
          searchInput.value = normalizedTerm;
        }
      }
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close();
  }

  open() {
    setScrollbarWidth();
    setHeaderBottomPosition();
    
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('search-modal--open');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close() {
    removeTrapFocus();
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('search-modal--open');
    document.dispatchEvent(new CustomEvent('searchmodal:close'));
  }

  reset(event) {
    event.preventDefault();
    this.querySelector('input[type="search"]').value = '';
  }
}

customElements.define('search-modal', SearchModal);
